import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {
  Popover,
  Button,
  Select,
  Text,
  TextInput,
  Grid,
} from '../..';
import withContext from '../../WithContext';
import { Consumer } from '../Context';


const OperatorText = styled.p`
  text-align: center;
  margin: 1em;
`;

const ApplyButton = styled(Button)`
  margin-top: 1em;
  float: right;
`;

const propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      operatorText: PropTypes.string,
      type: PropTypes.string,
      // eslint-disable-next-line react/forbid-prop-types
      options: PropTypes.array,
    }),
  ).isRequired,
  onAddFilter: PropTypes.func.isRequired,
  context: PropTypes.shape({
    resourceName: PropTypes.shape({
      singular: PropTypes.string,
      plural: PropTypes.string,
    }),
  }).isRequired,
  searchTerm: PropTypes.string,
  onQueryChange: PropTypes.func,
};

const defaultProps = {
  searchTerm: null,
  onQueryChange: null,
};

class FilterCreator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popOverActive: false,
      selectedFilter: undefined,
      selectedFilterKey: undefined,
      selectedFilterValue: undefined,
    };
  }

handlePopOverState = () => {
  this.setState(state => ({
    popOverActive: !state.popOverActive,
  }));
}

handleFilterChange = ({ value }) => {
  const { filters } = this.props;
  const foundFilter = filters.find(filter => filter.key === value);
  if (foundFilter) {
    this.setState({ selectedFilter: foundFilter, selectedFilterKey: value });
  }
}

handleFilterValueChange = ({ value }) => {
  this.setState({ selectedFilterValue: value });
}

handleApply = () => {
  const { selectedFilter, selectedFilterKey, selectedFilterValue } = this.state;
  const { onAddFilter } = this.props;
  onAddFilter({ key: selectedFilterKey, value: selectedFilterValue, label: selectedFilter.label });
  this.setState({
    popOverActive: false,
    selectedFilter: undefined,
    selectedFilterKey: undefined,
    selectedFilterValue: undefined,
  });
}

isFilterAvailable = () => {
  // Disable the button if the value is not selected.
  const { selectedFilter, selectedFilterKey, selectedFilterValue } = this.state;
  return !(selectedFilter && selectedFilterKey && selectedFilterValue);
}

render() {
  const { popOverActive, selectedFilter } = this.state;
  const {
    context: { resourceName: { plural } }, filters, searchTerm, onQueryChange,
  } = this.props;
  const filterOptions = filters.map(({ key, label }) => ({
    value: key,
    text: label,
  }));
  // showFilterSelectValue might get very large when we were to deal with many filtering types,
  // move this to a new component when that happens.

  let showFilterSelectValue = null;
  if (selectedFilter) {
    const { type } = selectedFilter;
    switch (type) {
      case 'Select': {
        const { options } = selectedFilter;
        const filterValueOptions = options.map(option => ({
          value: option.toString(),
          text: option.toString(),
        }));
        showFilterSelectValue = (
          <Select
            data={filterValueOptions}
            onChange={this.handleFilterValueChange}
            placeholder="Choose filter value"
          />
        );
        break;
      }
      default:
    }
  }
  const operatorText = selectedFilter
                       && (<OperatorText>{selectedFilter.operatorText}</OperatorText>);

  const saveButton = selectedFilter
                     && (
                     <ApplyButton onClick={this.handleApply} disabled={this.isFilterAvailable()}>
                       Apply
                     </ApplyButton>
                     );
  const popOverContent = (
    <>
      <Text>{`Show all ${plural} where`}</Text>
      <Select
        data={filterOptions}
        placeholder="Choose a filter"
        onChange={this.handleFilterChange}
      />
      {operatorText}
      {showFilterSelectValue}
      {saveButton}
    </>
  );
  return (
    <Grid gutterWidth={0} padding="lg" paddingLeft="2em">
      <Grid.Item span={7}>
        <TextInput
          name="name"
          value={searchTerm}
          onChange={onQueryChange}
          placeholder={`search ${plural}`}
        />
      </Grid.Item>
      <Grid.Item span={3}>
        <Popover
          content={popOverContent}
          isOpen={popOverActive}
          placement="right"
        >
          <Button onClick={this.handlePopOverState} size="large">Add Filters</Button>
        </Popover>
      </Grid.Item>
    </Grid>
  );
}
}

FilterCreator.propTypes = propTypes;
FilterCreator.defaultProps = defaultProps;
export default withContext(Consumer)(FilterCreator);
